import Main from "./Main";
import ActivatedVouchers from "./ActivatedVouchers";
import UsedVouchers from "./UsedVouchers";

export default { Main, ActivatedVouchers, UsedVouchers };
